var map = {
	"./ion-action-sheet-controller_8.entry.js": [
		"b628",
		"chunk-03a3b882"
	],
	"./ion-action-sheet-ios.entry.js": [
		"f1fc",
		"chunk-55740014"
	],
	"./ion-action-sheet-md.entry.js": [
		"fcd0",
		"chunk-42c9b51a"
	],
	"./ion-alert-ios.entry.js": [
		"bf7f",
		"chunk-1f01ba41"
	],
	"./ion-alert-md.entry.js": [
		"2ced",
		"chunk-cf035038"
	],
	"./ion-app_8-ios.entry.js": [
		"4078",
		"chunk-40389203"
	],
	"./ion-app_8-md.entry.js": [
		"a805",
		"chunk-17df5384"
	],
	"./ion-avatar_3-ios.entry.js": [
		"d1d6",
		"chunk-7654979d"
	],
	"./ion-avatar_3-md.entry.js": [
		"2822",
		"chunk-0757a354"
	],
	"./ion-back-button-ios.entry.js": [
		"6a57",
		"chunk-d09df222"
	],
	"./ion-back-button-md.entry.js": [
		"53f8",
		"chunk-7abcb7ec"
	],
	"./ion-backdrop-ios.entry.js": [
		"47f7",
		"chunk-2d0c1f4a"
	],
	"./ion-backdrop-md.entry.js": [
		"a40f",
		"chunk-2d20825f"
	],
	"./ion-button_2-ios.entry.js": [
		"32cb",
		"chunk-d968f544"
	],
	"./ion-button_2-md.entry.js": [
		"bbf3",
		"chunk-d6d98622"
	],
	"./ion-card_5-ios.entry.js": [
		"9553",
		"chunk-72f73b22"
	],
	"./ion-card_5-md.entry.js": [
		"19bf",
		"chunk-13d808b0"
	],
	"./ion-checkbox-ios.entry.js": [
		"d98b",
		"chunk-2e3dea86"
	],
	"./ion-checkbox-md.entry.js": [
		"9522",
		"chunk-5ae09e80"
	],
	"./ion-chip-ios.entry.js": [
		"87e5",
		"chunk-c5ec1966"
	],
	"./ion-chip-md.entry.js": [
		"775e",
		"chunk-6f8305ec"
	],
	"./ion-col_3.entry.js": [
		"6a8a",
		"chunk-2d0da04a"
	],
	"./ion-datetime_3-ios.entry.js": [
		"495e",
		"chunk-1236b7ea"
	],
	"./ion-datetime_3-md.entry.js": [
		"2aa2",
		"chunk-35303782"
	],
	"./ion-fab_3-ios.entry.js": [
		"41d0",
		"chunk-c17a989a"
	],
	"./ion-fab_3-md.entry.js": [
		"c0b4",
		"chunk-0cf8d3fd"
	],
	"./ion-img.entry.js": [
		"9588",
		"chunk-2d0e5812"
	],
	"./ion-infinite-scroll_2-ios.entry.js": [
		"5bdc",
		"chunk-af53ba2c"
	],
	"./ion-infinite-scroll_2-md.entry.js": [
		"3acb",
		"chunk-af55936a"
	],
	"./ion-input-ios.entry.js": [
		"4d6d",
		"chunk-287bfebe"
	],
	"./ion-input-md.entry.js": [
		"037b",
		"chunk-26cd360e"
	],
	"./ion-item-option_3-ios.entry.js": [
		"4121",
		"chunk-4bfff9a0"
	],
	"./ion-item-option_3-md.entry.js": [
		"2dcf",
		"chunk-4fd53c67"
	],
	"./ion-item_8-ios.entry.js": [
		"c899",
		"chunk-48aa0eb2"
	],
	"./ion-item_8-md.entry.js": [
		"9c96",
		"chunk-13b67bd6"
	],
	"./ion-loading-ios.entry.js": [
		"a9f3",
		"chunk-b133bd62"
	],
	"./ion-loading-md.entry.js": [
		"568c",
		"chunk-76ed02b0"
	],
	"./ion-menu_4-ios.entry.js": [
		"1413",
		"chunk-e10b5e90"
	],
	"./ion-menu_4-md.entry.js": [
		"83f2",
		"chunk-276d98b6"
	],
	"./ion-modal-ios.entry.js": [
		"d3e0",
		"chunk-a3226176"
	],
	"./ion-modal-md.entry.js": [
		"005e",
		"chunk-6fab0da2"
	],
	"./ion-nav_5.entry.js": [
		"9c3e",
		"chunk-41db7d2e"
	],
	"./ion-popover-ios.entry.js": [
		"646f",
		"chunk-17e4da91"
	],
	"./ion-popover-md.entry.js": [
		"cf49",
		"chunk-895ed252"
	],
	"./ion-progress-bar-ios.entry.js": [
		"d984",
		"chunk-cb3bc3aa"
	],
	"./ion-progress-bar-md.entry.js": [
		"a831",
		"chunk-6815f227"
	],
	"./ion-radio_2-ios.entry.js": [
		"20ea",
		"chunk-19749bdc"
	],
	"./ion-radio_2-md.entry.js": [
		"4386",
		"chunk-4c152a7f"
	],
	"./ion-range-ios.entry.js": [
		"b74f",
		"chunk-23d04875"
	],
	"./ion-range-md.entry.js": [
		"1f2e",
		"chunk-698cf714"
	],
	"./ion-refresher_2-ios.entry.js": [
		"0128",
		"chunk-af59c236"
	],
	"./ion-refresher_2-md.entry.js": [
		"9626",
		"chunk-af516e02"
	],
	"./ion-reorder_2-ios.entry.js": [
		"68cb",
		"chunk-5236e874"
	],
	"./ion-reorder_2-md.entry.js": [
		"c026",
		"chunk-524b3904"
	],
	"./ion-ripple-effect.entry.js": [
		"c8da",
		"chunk-2d218068"
	],
	"./ion-route_4.entry.js": [
		"10e8d",
		"chunk-1bf2d694"
	],
	"./ion-searchbar-ios.entry.js": [
		"4579",
		"chunk-4bd21d71"
	],
	"./ion-searchbar-md.entry.js": [
		"7dfb",
		"chunk-173239cb"
	],
	"./ion-segment_2-ios.entry.js": [
		"2e86",
		"chunk-f9bc50ea"
	],
	"./ion-segment_2-md.entry.js": [
		"866f",
		"chunk-5afd4824"
	],
	"./ion-select_3-ios.entry.js": [
		"9317",
		"chunk-147347c2"
	],
	"./ion-select_3-md.entry.js": [
		"4518",
		"chunk-1d09176a"
	],
	"./ion-slide_2-ios.entry.js": [
		"332a",
		"chunk-2d0b95c5"
	],
	"./ion-slide_2-md.entry.js": [
		"a4a9",
		"chunk-2d208821"
	],
	"./ion-spinner.entry.js": [
		"e11b",
		"chunk-685f1802"
	],
	"./ion-split-pane-ios.entry.js": [
		"f0b4",
		"chunk-2d22bf12"
	],
	"./ion-split-pane-md.entry.js": [
		"cc6d",
		"chunk-2d221c44"
	],
	"./ion-tab-bar_2-ios.entry.js": [
		"ae2e",
		"chunk-62fecb36"
	],
	"./ion-tab-bar_2-md.entry.js": [
		"df13",
		"chunk-68f689f8"
	],
	"./ion-tab_2.entry.js": [
		"6725",
		"chunk-90f00036"
	],
	"./ion-text.entry.js": [
		"ed3b",
		"chunk-310e4a24"
	],
	"./ion-textarea-ios.entry.js": [
		"6d1b",
		"chunk-451c033d"
	],
	"./ion-textarea-md.entry.js": [
		"4680",
		"chunk-e1d3363c"
	],
	"./ion-toast-ios.entry.js": [
		"5bda",
		"chunk-99349a2c"
	],
	"./ion-toast-md.entry.js": [
		"5c21",
		"chunk-7466af47"
	],
	"./ion-toggle-ios.entry.js": [
		"6daf",
		"chunk-724db1a8"
	],
	"./ion-toggle-md.entry.js": [
		"ae8d",
		"chunk-cc206ae2"
	],
	"./ion-virtual-scroll.entry.js": [
		"5fd7",
		"chunk-2d0d43da"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "05fe";
module.exports = webpackAsyncContext;